import React, { useMemo, useState } from 'react';
import axios from 'axios';
import { Send, CheckCircle2 } from 'lucide-react';

const PublicLeadForm = () => {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const leadKey = params.get('key') || 'theblackdiv-dev-leads-key';
  const source = params.get('source') || 'embedded form';
  const title = params.get('title') || 'Get a Quote';
  const subtitle = params.get('subtitle') || 'Tell us what you need and our team will contact you.';
  const theme = params.get('theme') || 'dark';
  const [form, setForm] = useState({
    name: '',
    companyName: '',
    email: '',
    phone: '',
    serviceInterest: '',
    budget: '',
    message: '',
  });
  const [state, setState] = useState({ loading: false, success: false, error: '' });
  const set = (key, value) => setForm(current => ({ ...current, [key]: value }));

  const submit = async (e) => {
    e.preventDefault();
    setState({ loading: true, success: false, error: '' });
    try {
      const apiBase = window.location.origin.includes('localhost') ? '' : window.location.origin;
      await axios.post(`${apiBase}/api/leads/public`, { ...form, source }, { headers: { 'x-lead-key': leadKey } });
      setState({ loading: false, success: true, error: '' });
      setForm({ name: '', companyName: '', email: '', phone: '', serviceInterest: '', budget: '', message: '' });
    } catch (err) {
      setState({ loading: false, success: false, error: err.response?.data?.message || 'Something went wrong' });
    }
  };

  return (
    <div className={`embedded-form-page ${theme === 'light' ? 'embedded-form-light' : ''}`}>
      <form className="embedded-form-card" onSubmit={submit}>
        <div className="embedded-form-brand">
          <div className="embedded-form-mark">+</div>
          <div>
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
        </div>

        {state.success && (
          <div className="embedded-form-success">
            <CheckCircle2 size={18} />
            <span>Thanks. Your request has been sent.</span>
          </div>
        )}
        {state.error && <div className="embedded-form-error">{state.error}</div>}

        <div className="embedded-form-grid">
          <input required value={form.name} onChange={e => set('name', e.target.value)} placeholder="Your name" />
          <input value={form.companyName} onChange={e => set('companyName', e.target.value)} placeholder="Company name" />
          <input required type="email" value={form.email} onChange={e => set('email', e.target.value)} placeholder="Email address" />
          <input value={form.phone} onChange={e => set('phone', e.target.value)} placeholder="Phone number" />
        </div>
        <input value={form.serviceInterest} onChange={e => set('serviceInterest', e.target.value)} placeholder="Service you need" />
        <input value={form.budget} onChange={e => set('budget', e.target.value)} placeholder="Estimated budget" />
        <textarea value={form.message} onChange={e => set('message', e.target.value)} rows={4} placeholder="Project details"></textarea>
        <button type="submit" disabled={state.loading}>
          <Send size={16} />
          {state.loading ? 'Sending...' : 'Send Request'}
        </button>
      </form>
    </div>
  );
};

export default PublicLeadForm;
